import isEmptyField from './isEmptyField';
/**
 * Check for required field
 * @value {Object|Array|number|string|null}
 * @errorMessage {string|null}
 * @returns {string|null}
 */
const required = (value, errorMessage = 'Поле обязательно для заполнения') =>
  !value || isEmptyField(value) ? errorMessage : null;

export default required;
